import { useEffect, useState } from "react";

import { Table } from "../../../../../../Components/FinalTable";

import THeader from "./THeader";

import TBody from "./TBody";

import TInfo from "./TInfo";

import TContext from "./TContext";

import { TableTopBar } from "../../../../../../Components/FinalTable";

import BtnRounded from "../../../../../../Components/Buttons/BtnRounded";

import { useNavigate, useParams } from "react-router-dom";

import useApp from "../../../../../../Hooks/useApp";

import useAxios from "../../../../../../Hooks/useAxios";

import Fuse from "fuse.js";

const LiveData = ({ showLive, setShowLive }) => {
  const [checked_id, setCheckedId] = useState(-1);
  const { id } = useParams();
  const navigate = useNavigate();
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [sortOrder, setSortOrder] = useState("desc");
  const [sortField, setSortField] = useState("created_at");
  const [hasNextPage, setHasNextPage] = useState(false);
  const [hasPrevPage, setHasPrevPage] = useState(false);
  const [data, setData] = useState([]);
  const [showPagination, setShowPagination] = useState(true);
  const [filters, setFilters] = useState({});

  const [tableIsLoading, setTableIsLoading] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);

  const [searchInput, setSearchInput] = useState("");
  const [visitId, setVisitId] = useState(0);
  const request = useAxios();
  const { setShowFormModal, setModalMessage, setShowSuccessModal, user } =
    useApp();
  const [docs, setDocs] = useState(0);

  useEffect(() => {
    getInitInvestigations(1, "created_at", "desc", filters);
  }, [limit]);

  useEffect(() => {
    if (searchInput.length < 3) return;

    async function search() {
      setTableIsLoading(true);
      //(searchInput)
      let res = await request({
        method: "GET",
        url: "hospital/investigations/search",
        params: {
          value: searchInput,
        },
      });
      if (res === "network-error" || res === "error") {
        navigate("/dashboard/user-queue");
        return;
      }

      setShowLive(true);
      setData(res);

      setShowPagination(false);
      setIsFiltered(true);
      setTableIsLoading(false);
    }

    search();
  }, [searchInput]);

  async function getInitInvestigations(
    page = 1,
    sort_field = "created_at",
    sort_order = "desc",
    filters = {}
  ) {
    setTableIsLoading(true);
    let res = await request({
      method: "GET",
      url: `hospital/investigations`,
      params: {
        page,
        limit,
        sort_field: sort_field,
        sort_order: sort_order,
        ...filters,
      },
      network_error: false,
    });

    if (res === "network-error" || res === "error") {
      navigate("/dashboard/user-queue");
      return;
    }

    setTableIsLoading(false);
    setData(res.docs);
    setHasNextPage(res.hasNextPage);
    setHasPrevPage(res.hasPrevPage);
  }
  useEffect(() => {
    async function Initialize() {
      let res = await request({
        method: "GET",
        url: `hospital/records/consultation?visit_step_id=${id}`,
      });

      if (res === "network-error" || res === "error") {
        navigate("/dashboard/user-queue");
        return;
      }

      setVisitId(res.visit.id);
    }

    Initialize();
  }, []);
  async function handleNext() {
    if (hasNextPage) {
      setPage(page + 1);
      getInitInvestigations(page + 1, sortField, sortOrder);
    }
  }

  async function handlePrev() {
    if (hasPrevPage) {
      setPage(page - 1);
      getInitInvestigations(page - 1, sortField, sortOrder);
    }
  }

  async function handleFilterQuery(filters) {
    setSortField("created_at");
    setSortOrder("desc");
    getInitInvestigations(1, "created_at", "desc", filters);

    setIsFiltered(true);
    setFilters(filters);
  }

  async function handleHeaderQuery(field, order) {
    setPage(1);
    setSortOrder(order);
    setSortField(field);
    getInitInvestigations(1, field, order);
  }

  async function handleClearFilters() {
    await getInitInvestigations(1, "created_at", "desc");
    setPage(1);
    setSortField("created_at");
    setSortOrder("desc");
    setIsFiltered(false);
    setShowPagination(true);
    setSearchInput("");
  }

  async function Submit() {
    if (docs.length === 0) {
      setModalMessage("Select at least one investigation");
      setShowFormModal(true);
      return;
    }
    let res = await request({
      method: "POST",
      url: "hospital/visit/investigations",
      data: {
        visit_id: parseInt(visitId),
        investigation_id: parseInt(checked_id),
        requested_by: parseInt(user.id),
      },
    });

    if (res !== "error") {
      setModalMessage("Investigation Added");
      setShowSuccessModal(true);
      navigate(`/dashboard/attend/${id}`);
    }
  }
  useEffect(() => {}, [id]);

  return (
    <TContext.Provider
      value={{
        showLive,
        limit,
        setLimit,
        data,
        page,
        hasNextPage,
        hasPrevPage,
        handleNext,
        handlePrev,
        handleHeaderQuery,
        handleFilterQuery,
        isFiltered,
        handleClearFilters: handleClearFilters,
        total: "...",
        setIsFiltered,
        showPagination,
        resetQuery: handleClearFilters,
        checked_id,
        setCheckedId,
        docs,
        setDocs,
      }}
    >
      <div className="px-7 pb-8">
        <TableTopBar
          mt={2}
          mb={2}
          showAdd={false}
          // AddClick={handleAdd}
          changes={0}
          handleLiveStream={() => {}}
          isFiltered={isFiltered}
          handleClearFilters={handleClearFilters}
          tableIsLoading={tableIsLoading}
          showReport={false}
          showFilter={false}
          // addLabel="Add"
          searchInput={searchInput}
          setSearchInput={setSearchInput}
        />
        <Table>
          <THeader />
          <TBody />
          <TInfo />
          <div className="max-w-2xl w-full mx-auto">
            <BtnRounded mt={2} click={Submit} className="btn">
              <span className=" font-pop-reg">Add Investigation</span>
              <span className="px-3 font-normal text-2xl"></span>
            </BtnRounded>
          </div>
        </Table>
      </div>
    </TContext.Provider>
  );
};

export default LiveData;
